import {
  FETCH_DELIVERY_TIME,
  DELIVERY_TIME_LOADING,
  UPDATE_PROMOTION,
} from "./actionTypes";
import instance from "./instance";
import { edit_quantity, remove_from_cart, updatePromotions } from "./cart";
import { calculate_prep_time } from "../reducers/cart";

export const fetchDeliveryTime = () => {
  return async (dispatch, getState) => {
    try {
      const cart = getState().cart;
      const settings = getState().store.store.settings;
      const selectedFulfilmentType = getState().deliveryTime.type;
      let isPickup;
      let branch = null;
      let bdc = null;
      let pickupBranchStoreBased = null;
      if (settings.is_branch_based_ordering) {
        if (getState().branch.isPickup) isPickup = true;
        else isPickup = false;

        branch = getState().branch.branch;
        bdc = getState().branch.bdc;
        if (!branch) return;
      } else {
        if (getState().customers.address) {
          if (getState().customers.address.selectedDeliveryType == 1) {
            isPickup = true;
            pickupBranchStoreBased = getState().customers.address.pickupArea;
          } else isPickup = false;
        } else isPickup = true;
      }
      dispatch({ type: DELIVERY_TIME_LOADING, payload: true });
      const res = await instance.post("/get_delivery_time/", {
        prep_time: calculate_prep_time(
          [...cart.cart, ...cart.promo_items],
          settings.sum_product_prep_time
        ),
        is_pickup: isPickup,
        branch: branch,
        bdc: bdc,
        cart: cart,
        pickupBranchStoreBased: pickupBranchStoreBased,
        country: getState().customers?.address?.country,
        area: getState().customers?.address?.area,
      });

      if (res.data.changeQuantities) {
        EditQuantities(res.data.changeQuantities, cart, dispatch);
      } else if (res.data) {
        dispatch({
          type: FETCH_DELIVERY_TIME,
          payload: { ...res.data, isPickup: isPickup },
        });
        if (!selectedFulfilmentType) {
          dispatch(updatePromotions());
        }
      }
    } catch (err) {
      console.error(err);
    }
    dispatch({ type: DELIVERY_TIME_LOADING, payload: false });
  };
};

const EditQuantities = (products, cart, dispatch) => {
  let ProductQuantities;
  let ProductTotal;
  let quantityToBeDeducted;
  let removedProducts;

  for (const product_id in products) {
    ProductQuantities = {};
    ProductTotal = 0;
    removedProducts = 0;
    cart.cart.forEach((prod, index) => {
      if (
        prod.id == product_id &&
        (!products[product_id].is_preordered ||
          products[product_id].is_preordered === prod.is_preordered)
      ) {
        ProductQuantities[index] = prod.quantity;
        ProductTotal += prod.quantity;
      }
    });
    quantityToBeDeducted = ProductTotal - products[product_id].max;

    for (const product in ProductQuantities) {
      if (
        products[product_id].is_preordered ||
        ProductQuantities[product] <= quantityToBeDeducted
      ) {
        dispatch(
          remove_from_cart(
            product - removedProducts,
            cart.cart[product],
            false,
            products[product_id].is_preordered
          )
        );
        quantityToBeDeducted -= ProductQuantities[product];
        ProductTotal -= ProductQuantities[product];
        removedProducts += 1;
      } else if (quantityToBeDeducted > 0) {
        dispatch(
          edit_quantity(
            parseInt(product - removedProducts),
            cart.cart[product],
            ProductQuantities[product] - quantityToBeDeducted,
            -quantityToBeDeducted,
            false,
            cart.cart[product].is_preordered,
            products[product_id].max
          )
        );
      }
    }
  }

  dispatch({ type: "SHOW_CHECK_CART" });
  dispatch(fetchDeliveryTime());
};

export const setDrawer = (state) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "SET_DELIVERY_TIME_DRAWER", payload: state });
    } catch (err) {
      console.error(err);
    }
  };
};
